import { render, staticRenderFns } from "./AddClassflx.vue?vue&type=template&id=38855f30&scoped=true"
import script from "./AddClassflx.vue?vue&type=script&lang=js"
export * from "./AddClassflx.vue?vue&type=script&lang=js"
import style0 from "./AddClassflx.vue?vue&type=style&index=0&id=38855f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38855f30",
  null
  
)

export default component.exports